import { render, staticRenderFns } from "./RelaxationProtocolCard.vue?vue&type=template&id=2ae64332&"
import script from "./RelaxationProtocolCard.vue?vue&type=script&lang=js&"
export * from "./RelaxationProtocolCard.vue?vue&type=script&lang=js&"
import style0 from "./RelaxationProtocolCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports